// extracted by mini-css-extract-plugin
module.exports = {"rankBadgeContainer":"RankBadge_rankBadgeContainer__wr61n"};